import { useEffect } from "react";

export const SITE_URL = "https://mycleaner.nl";
const OG_IMAGE = "https://customer-assets.emergentagent.com/job_cleaner-connect-30/artifacts/3wa4dk27_wmremove-transformed.jpeg";

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * SEO head manager for this SPA. Sets title, meta, canonical, OG, Twitter and JSON-LD.
 */
const Seo = ({ title, description, path = "/", image = OG_IMAGE, jsonLd = [] }) => {
  const url = `${SITE_URL}${path}`;
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertLink("canonical", url);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:site_name", "MyCleaner");
    upsertMeta("property", "og:locale", "nl_NL");

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    const blocks = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    const nodes = blocks.filter(Boolean).map((data) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "1");
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      return s;
    });
    return () => nodes.forEach((n) => n.remove());
  }, [title, description, url, image, JSON.stringify(jsonLd)]);

  return null;
};

export default Seo;
